module.exports = __webpack_public_path__ + "static/media/19ESCAP1.b72630fe.jpg";